import styled from 'styled-components';

import {Row} from '../../common/Layouts/Layouts';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

export const RatingRow = styled(Row)(
  props => `
  width: 50%;
  padding-right: 130px;
`,
);

export const WrapperDiv = styled(Row)(
  props => `
  width: 70%;
  padding-left: ${props.theme.spacing.large};
`,
);

export const ReviewTypeTextWrapper = styled.span(
  props => `
  padding-right: ${props.theme.spacing.small};
  font-size: ${props.theme.font.custom(16)};
`,
);

export const ProgressBarWrapperDiv = styled(Row)(
  props => `
  padding-top: ${props.theme.spacing.custom(3)};
  width: 27.5rem;
`,
);

export const ReviewHeaderWrapper = styled.div(
  props => `
  display:flex;
  justify-content:space-between;
  align-items: center;
  width: 100%;
`,
);

export const ExternalGuestReviewWrapper = styled.section(
  props => `
    width: 100%;
    margin: 0 auto;
    max-width:120rem;
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    margin-top: ${props.theme.spacing.large};
  `,
);

export const EGRInnerWrapper = styled.div(
  props => `
    display:flex;
    padding: ${props.theme.spacing.xlarge};
    border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  `,
);

export const FlexContainerWrap = styled.div(
  props => `
    display:flex;
  `,
);

export const GoRatingBlock = styled.div(props => {
  return `
      background-color: ${getRatingsColor(props.hotelRating)};
      display:flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 14.5rem;
      color: ${props.theme.colors.goWhite.base};
      border-radius: ${props.theme.misc.borderRadius.large};
      padding: ${props.theme.font.custom(10)} 0;
    `;
});

export const AvgReviewTextWrapperDiv = styled.p(
  props => `
    flex-direction: row;
    align-items: flex-end;
    padding: 2rem 2rem 0;
  `,
);

export const AvgReviewTextWrapper = styled.span(
  props => `
    font-size: ${props.theme.font.custom(32)};
    align-items: center;
    font-weight: ${props.theme.font.fwbold};
  `,
);

export const TotalReviewTextWrapper = styled.span(
  props => `
    font-size: ${props.theme.font.custom(26)};
    align-items: center;
    font-weight: ${props.theme.font.fwSemiBold};  `,
);

export const RatingsCountTextWrapper = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    align-items: center;
    padding-bottom: ${props.theme.spacing.xlarge};
  `,
);
